// IMPORT SERVICES
import { CBService } from "../services/api";
const api = new CBService()

// IMPORT CUSTOM LIBRARIES
import TriggerAnimation from './triggerAnimation';

declare var gsap: any;

interface ReferenceElement<T> {
    selector?: string, target?: T | undefined | null;
}

interface RecipesConfig {
    filters?: RecipeFilters;
    seeker?: string;
    on?: any;
}

interface RecipeFilters {
    category?: string;
    subcategory?: string;
    filter?: string;
}

interface RecipeList {
    [location: string]: any
}

export default class Recipes {
    listContainer: ReferenceElement<HTMLElement>;
    config: RecipesConfig;
    recipeList: RecipeList = [];
    filters: RecipeFilters;
    timeOut: any;

    constructor(recipesWrapper: string, config: RecipesConfig) {
        this.listContainer = { selector: recipesWrapper, target: document.querySelector(recipesWrapper) as HTMLElement };
        this.config = config;
        this.filters = { category: '', subcategory: '', filter: '', ...config.filters };
        this.updateRecipes();
        this.listenInputSeeker();

    }

    listenInputSeeker(): void {
        let { seeker } = this.config

        if (seeker) {
            document.querySelector(seeker)?.addEventListener('input', (e: any) => {
                const filter = e.target.value
                this.filters = { ...this.filters, filter }
            })
            document.querySelector(seeker)?.addEventListener('keyup', (e: any) => {
                if (e.keyCode === 13) {
                    this.updateRecipes()
                }
            })
            document.querySelector('.cp-seeker__icon')?.addEventListener('click', () => {
                this.updateRecipes()
            })
        }
    }

    async getRecipeList(filter?: any): Promise<any> {
        let recipeFilter =
            filter ?
                { ...this.filters, [filter.type]: filter.value } :
                this.filters

        this.filters = recipeFilter

        try {
            let response: any = await api.getRecipes(recipeFilter)
            return response.items

        } catch (error) {
            console.log('error en la consulta:', error);
        }
    }

    showNoFoundCard(): void {
        let { target } = this.listContainer;

        target?.insertAdjacentHTML('beforeend',
            `<div class="swiper-slide">
                <div class="cp-card-recipe cp-card-recipe--no-found">
                    <picture class="cp-card-recipe__image lazyload"></picture>
                    <article class="cp-card-recipe__article cp-card-recipe__article--no-found">
                        <h3 class="cp-card-recipe__title">UPPS!!!</h3>
                        <p class="cp-card-recipe__desc">Lo sentimos no encontramos <br>nada con tu búsqueda</p>
                        <p class="cp-card-recipe__try-again">Intenta de nuevo</p>
                    </article>
                </div>
            </div>`
        )
    }

    createCardMarkup(recipe: any): void {
        let { target } = this.listContainer;
        // let description = recipe.desc.length > 150 ? `${recipe.desc.slice(0, 150)}...` : recipe.desc

        target?.insertAdjacentHTML('beforeend',
            `<div class="swiper-slide">
                <div class="cp-card-recipe">
                    <span class="cp-card-recipe__location">${recipe.category}</span>
                    <picture class="cp-card-recipe__image">
                        <img class="lazyload" data-src="${recipe.image}" alt="" title="" width="275" height="240">
                    </picture>
                    <article class="cp-card-recipe__article">
                        <h3 class="cp-card-recipe__title">${recipe.title}</h3>
                        <span class="cp-card-recipe__category">${recipe.subtitle}</span>
                        <p class="cp-card-recipe__desc">${recipe.desc}</p>
                        <a class="cp-card-recipe__btn cp-button" data-recipe-title="${recipe.title}" href="${recipe.videoid}">ver video</a>
                    </article>
                </div>
            </div>`
        )
    }

    updateRecipes(filter?: { type: string, value: string }): any {
        let { on } = this.config
        let { target } = this.listContainer
        
        clearTimeout(this.timeOut)

        this.timeOut = setTimeout(() => {
            this.getRecipeList(filter).then((response) => {
                if (target) target.innerHTML = '';
                this.recipeList = response

                if (!this.recipeList || this.recipeList.length == 0) {
                    this.showNoFoundCard()
                }
                else {
                    for (let recipe in this.recipeList) {
                        this.recipeList[recipe].forEach(this.createCardMarkup.bind(this))
                    }
                }

                on.update()
                this.setAnimation()
            })
        }, 200)
    }

    setAnimation(isFirstTime: boolean = true): void {
        if (isFirstTime) {
            let recipeCard = new TriggerAnimation('.cp-card-recipe', {
                mobile: {
                    from: { translateX: 30, opacity: 0 },
                    to: {
                        translateX: 0, stagger: 0.2, scrollTrigger: {
                            trigger: '#recipeSwiper', start: 'top bottom-=150px'
                        }
                    }
                }
            })
            recipeCard.triggerAnimation()
        }
        else {
            gsap.from('.cp-card-recipe', {
                duration: 0.8, stagger: 0.2, opacity: 0, translateX: 30
            })
        }
    }
}


export class Filter {
    container: ReferenceElement<HTMLElement>;
    filterList: Array<any>;

    constructor(selector: string, { filterList, createElement, onCreated }: any) {
        this.container = { selector, target: document.querySelector(selector) as HTMLElement };
        this.filterList = filterList
        this.onCreated = onCreated
        this.createElement = createElement
        this.init()

    }

    init() {
        let { target } = this.container

        this.filterList.forEach(filter => {
            target?.insertAdjacentHTML('beforeend',
                `${this.createElement(filter)}`
            )
        })

        this.onCreated?.()
    }

    createElement(props: any): void { }

    onCreated(): void { }
}